import React, { Component } from 'react'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

// CSS
import '../../../css/display-table.css'

class LowInventory extends Component {
    constructor(props){
        super(props)
        this.state = {
            dataLoaded: false,
            data: null,
            error: '',
            exporting: false,
            exportedFile: ""
        }
    }

    componentDidMount(){
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + 'summary/low-inventory', { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200){
                this.setState({ dataLoaded: true, error: response.data.message })
            }else{
                this.setState({ dataLoaded: true, data: { ...response.data } })
            }
		})
		.catch((err) => {
			this.setState({ dataLoaded: true, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
		})
    }

    exportData = () => {
        this.setState({
            exporting: true,
            exportedFile: ""
        }, () => {
            const item = {
                data: this.state.data,
                type: 'low_inventory'
            }
    
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
            return axios
            .post(REACT_APP_API_URL + "summary", item, { headers: AUTH_HEADER })
            .then((response) => {
                console.log(response);
                if(response.status !== 200){
                    this.setState({ error: response.data.message, exporting: false })
                }else{
                    this.setState({ exportedFile: response.data.file, exporting: false })
                }
            })
            .catch((err) => {
                this.setState({ error: err.response.data.errors ? err.response.data.errors : err.response.data.message, exporting: false })
            })
        })
    }

    render() {
        return (
            <div className="chart_area chart_1_2">
                <div className="chart_area_header">
                    <h2>Low Inventory</h2>
                    <button className="btn export-btn" onClick={(e) => {
                        if(this.state.exportedFile !== ""){
                            e.preventDefault();
                            window.location.href = '' + this.state.exportedFile;
                        }
                        else{
                            this.exportData()
                        }
                    }}>
                    {this.state.exporting ? 'Exporting...' : (this.state.exportedFile === "" ? 'Export' : 'Download')}
                    </button>
                </div>
                {this.state.dataLoaded ? (
                    !isEmpty(this.state.data) ? (
                        <table className="display_table light_table">
                            <thead>
                                <tr className="table-header">
                                    <th></th>
                                    <th>Sku</th>
                                    <th className="right_aligned">Inventory</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(this.state.data).map((key, index) =>
                                    <tr key={key}>
                                        <td className="record-number">{index + 1}</td>
                                        <td data-id="Sku">{this.state.data[key].sku}</td>
                                        <td data-id="Inventory" className="right_aligned">{this.state.data[key].inventory}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    ) : (
                        <div>There are no low inventory products at this time!</div>
                    )
                ) : (
                    null
                )}
            </div>
        )
    }
}

export default LowInventory



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/LowInventory.js